import {
	DrawerBody,
	Stack,
	Box,
	Flex,
	Image,
	Text,
	Spacer,
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	ModalHeader,
	ModalCloseButton,
	useDisclosure,
	useToast,
	Progress,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { Raider } from "../../../../types/raider";
import { timeConverter, nameCleanup } from "../../../../util/helpers";
import {
	runHome,
	getRewardsToCollect,
	getTotalReturnTime,
} from "../../../../util/web3/interactQuests";

interface QuestProps {
	raider: Raider;
	questName: string;
	questIcon: string;
	rewardName: string;
	questString: string;
	timeTillHome: number;
}

export default function Returning(props: QuestProps) {
	const {
		raider,
		questName,
		questIcon,
		rewardName,
		questString,
		timeTillHome,
	} = props;
	const [rewardsToCollect, setRewardsToCollect] = useState<number>();
	const [totalReturnTime, setTotalReturnTime] = useState<number>();

	const toast = useToast();

	const runHomeModal = useDisclosure();

	useEffect(() => {
		const fetchData = async () => {
			setRewardsToCollect(
				await getRewardsToCollect(parseInt(raider.id), questString)
			);
			setTotalReturnTime(
				await getTotalReturnTime(parseInt(raider.id), questString)
			);
		};

		fetchData();
	}, []);

	return (
		<DrawerBody>
			<Stack spacing="6" py="2" px="2">
				<Box background="#4a556878" borderRadius="md" px={4} py={8}>
					<Flex mb="15px" justifyContent="left" alignItems="center">
						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/basicQuest.png"
							width="40px"
							height="40px"
							alt="quest"
						/>
						<Text textStyle="questStatusHeader">{questName}</Text>
					</Flex>

					<Flex alignItems="center">
						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/clock.png"
							alt="clock"
							width="20px"
							height="20px"
							mr="5px"
						/>
						<Text mr="5px">{nameCleanup(raider.name)} will be home in:</Text>
						{timeTillHome && (
							<Text textStyle="timeBlock">{timeConverter(timeTillHome)}</Text>
						)}
						<Spacer />
					</Flex>
					{totalReturnTime && timeTillHome && (
						<Progress
							value={(1 - timeTillHome / totalReturnTime) * 100}
							colorScheme="cyan"
							mt="16px !important"
						/>
					)}
					<Flex mt="16px !important">
						<Text mr="15px">Earned: </Text>
						<Image
							src={questIcon}
							width="25px"
							height="25px"
							alt={rewardName}
							mr="2px"
						/>
						<Text mr="15px">
							+{rewardsToCollect} {rewardName}
						</Text>

						<Image
							src="https://storage.googleapis.com/crypto-raiders-assets/web/currencies/herbalism.png"
							width="25px"
							height="25px"
							alt={rewardName}
							mr="2px"
						/>
						{rewardsToCollect != undefined && (
							<Text>+{rewardsToCollect * 10} Herbalism XP</Text>
						)}
					</Flex>
				</Box>
				<Button onClick={() => runHomeModal.onOpen()}>
					Teleport home with no rewards
				</Button>
			</Stack>
			<Modal
				isOpen={runHomeModal.isOpen}
				onClose={runHomeModal.onClose}
				size="lg"
			>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Teleport Home from {questName}?</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Text mb={5}>
							The Wizards of Auershire are happy to summon your Raider home in
							an emergency. If you need to end your quest and can&apos;t wait
							for {nameCleanup(raider.name)} to walk home, click below and
							they&apos;ll teleport home without any of their {rewardName} or
							experience.
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button
							colorScheme="red"
							variant="ghost"
							mr={3}
							onClick={runHomeModal.onClose}
						>
							Nevermind
						</Button>
						{questString && (
							<Button
								// rightIcon={<GiSwordsEmblem />}
								// isLoading={isLoading}
								colorScheme="green"
								onClick={() => runHome(parseInt(raider.id), questString, toast)}
							>
								Teleport Home Without Rewards
							</Button>
						)}
					</ModalFooter>
				</ModalContent>
			</Modal>
		</DrawerBody>
	);
}
